import axios from 'axios'
import config from "@/config/config";

const instance = axios.create({
  baseURL: config.baseUrl,
  timeout: 15000
});

instance.interceptors.response.use(async (response) => {
        if(response.data.success === false && response.data.error_code === 'no_auth'){
           // store.dispatch('regenLoginTokenAction');
        }
        return response;
    },
    async(error) => {
        return Promise.reject(error);
    });

if (localStorage.getItem('bearer') !== null) {
    instance.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('bearer')}`;
}

export default instance
